import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
function TrialBalance() {
    const [data, setData] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const fetchData = () => {
        const start = startDate
            ? startDate.toISOString().substring(0, 10)
            : '';
        const end = endDate
            ? endDate.toISOString().substring(0, 10)
            : '';
        axios.get(
            `${baseUrl}trial-balance/?start=${start}&end=${end}`
        )
            .then(res => {
                setData(res.data);
            })
            .catch(err => console.log(err));
    };
    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);
    const columns = [
        {
            field: 'account',
            headerName: 'Account Head',
            width: 300
        },
        {
            field: 'debit',
            headerName: 'Debit',
            width: 150
        },
        {
            field: 'credit',
            headerName: 'Credit',
            width: 150
        },
    ];
    return (
        <section className='container mt-4'>

            <h3 className='bg-success text-white text-center p-2'>
                Trial Balance
            </h3>

            <div className='row mb-3'>

                <div className='col-md-3'>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="From Date"
                        className='form-control'
                    />
                </div>

                <div className='col-md-3'>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="To Date"
                        className='form-control'
                    />
                </div>

            </div>

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid

                    className='mt-4'

                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'success.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'success.main',
                        },
                    }}

                    rows={data}
                    columns={columns}
                    autoHeight
                    pageSize={20}

                    slots={{
                        toolbar: GridToolbar,
                    }}

                />

            </div>

        </section>
    )
}
export default TrialBalance;